import axios from "axios";

const endPoint = process.env.REACT_APP_API_ENDPOINT;

export const questionsPQApi = async (data) => {
  const respose = await axios.get(
    `${endPoint}personalityquiz/get-questions`,
    data
  );
  return respose;
};

export const FinalResponsePQApi = async (data) => {
  const response = await axios.post(
    `${endPoint}quiz/update-question-answers`,
    data
  );
  return response;
};
